import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATE_META = {
  documented: { label: "Documented", cls: "bg-emerald-700 text-white" },
  supported_inference: { label: "Supported inference", cls: "bg-blue-700 text-white" },
  validation_required: { label: "Validation required", cls: "bg-amber-500 text-white" },
  evidence_gap: { label: "Evidence gap", cls: "bg-red-600 text-white" },
};

export const CLS_META = {
  reuse_directly: { label: "Reuse directly", cls: "bg-emerald-700 text-white" },
  reuse_with_contextualization: { label: "Reuse with contextualization", cls: "bg-blue-700 text-white" },
  localize: { label: "Localize", cls: "bg-amber-500 text-white" },
  local_validation_required: { label: "Local validation required", cls: "bg-orange-600 text-white" },
  generate_new_evidence: { label: "Generate new evidence", cls: "bg-red-600 text-white" },
  not_relevant: { label: "Not relevant", cls: "bg-slate-400 text-white" },
};

export const PROV_META = {
  documented: { label: "Documented", cls: "bg-emerald-700 text-white" },
  precedent_based: { label: "Precedent-based", cls: "bg-indigo-600 text-white" },
  mai_inferred: { label: "MAI inference", cls: "bg-blue-700 text-white" },
  expert_validation_required: { label: "Expert validation required", cls: "bg-amber-500 text-white" },
  unknown: { label: "Unknown", cls: "bg-slate-400 text-white" },
};

export const PROV_BAR = {
  documented: "bg-emerald-600", precedent_based: "bg-indigo-500",
  mai_inferred: "bg-blue-500", expert_validation_required: "bg-amber-400",
  unknown: "bg-slate-300",
};

export const ACTION_STATUS_META = {
  not_started: { label: "Not started", cls: "bg-slate-200 text-slate-600" },
  waiting_for_input: { label: "Waiting for input", cls: "bg-purple-600 text-white" },
  in_progress: { label: "In progress", cls: "bg-blue-700 text-white" },
  under_review: { label: "Under review", cls: "bg-indigo-600 text-white" },
  client_review: { label: "Client review", cls: "bg-amber-500 text-white" },
  completed: { label: "Completed", cls: "bg-emerald-700 text-white" },
  blocked: { label: "Blocked", cls: "bg-red-600 text-white" },
};

export const PRIORITY_META = {
  critical: "bg-red-600 text-white", high: "bg-amber-500 text-white",
  medium: "bg-slate-500 text-white", low: "bg-slate-300 text-slate-700",
};

export const Chip = ({ meta, testId }) => (
  <span data-testid={testId} className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${meta?.cls || "bg-slate-200 text-slate-600"}`}>
    {meta?.label || "—"}
  </span>
);

export const PriorityChip = ({ value }) => (
  <span className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${PRIORITY_META[value] || "bg-slate-200 text-slate-600"}`}>{value || "—"}</span>
);

export function useEntry(caseId, path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let live = true;
    setData(null); setError(null);
    axios.get(`${API}/access-cases/${caseId}${path}`)
      .then((r) => live && setData(r.data))
      .catch((e) => live && setError(e.message));
    return () => { live = false; };
  }, [caseId, path]);
  return { data, error };
}

export const Loading = ({ label = "Loading case intelligence…" }) => (
  <div className="py-16 text-center text-slate-400 text-sm">{label}</div>
);

export const ErrorBox = ({ error }) => (
  <div className="py-10 text-center text-sm text-red-600" data-testid="entry-error">Failed to load: {error}</div>
);

export const IntegrityNote = ({ text }) => (
  <p className="text-[11px] text-slate-500 italic mt-4 border-l-2 border-slate-300 pl-3">{text}</p>
);
